(ns nl.mediquest.questionnaire-frontend.component.survey
  (:require
   ["survey-core/survey.i18n"]
   ["survey-core" :refer [SvgRegistry]]
   [clojure.walk :as walk]
   [nl.mediquest.lib.router.navigation-protection :as-alias navigation-protection]
   [nl.mediquest.questionnaire-frontend.config :as config]
   [nl.mediquest.questionnaire-frontend.events :as events]
   [nl.mediquest.questionnaire-frontend.component.i18n :as i18n
    :refer [text-or-i18n]]
   [nl.mediquest.ui.core.modal :as modal]
   [re-frame.core :as re-frame]
   [survey-react-ui :refer [Survey]]))

(defn survey-complete [survey-submitted-to-server? survey]
  (when (compare-and-set! survey-submitted-to-server? false true)
    (re-frame/dispatch [::navigation-protection/protect false])
    (let [survey-data (js->clj (.-data survey) :keywordize-keys true)]
      (when config/debug?
        (prn ::survey-complete {:survey-data survey-data}))
      (if (seq survey-data)
        (re-frame/dispatch [::events/save-survey survey-data])
        (re-frame/dispatch [::events/notify-empty-response-not-send])))))

(defn default-modal [title description]
  [:div
   [:div.font-semibold (or title "Meer informatie")]
   [:div description]])

(defn open-modal [title description]
  (modal/open!
   (fn [] [default-modal title description])))

(defn hiccup? [d]
  (vector? (js->clj d)))

(defn js->possible-hiccup [d]
  (if (hiccup? d)
    (walk/postwalk
     (fn [x]
       (if (vector? x)
         (update x 0 keyword)
         x))
     (js->clj d :keywordize-keys true))
    [text-or-i18n (js->clj d :keywordize-keys true)]))

(defn- register-info-icon []
  (.registerIconFromSvg
   SvgRegistry
   "icon-custom-info"
   (str
    "<svg viewBox='0 0 24 24'>"
    "  <circle cx='12' cy='12' r='10' fill='none' stroke='currentColor' stroke-width='2'/>"
    "    <text x='12' y='17' text-anchor='middle' font-size='14' font-weight='bold' fill='currentColor'>"
    "      i"
    "    </text>"
    "</svg>")))

(defn add-title-action-to-question [_survey ^js options]
  (let [question (.. options -question)]
    (when-let [info-description (.-infoDescription question)]
      (set! (.-titleActions options)
            (clj->js
             [{:id "show-description"
               :iconName "icon-custom-info"
               :action (fn []
                         (open-modal (js->possible-hiccup (.. question -infoTitle))
                                     (or (js->possible-hiccup info-description)
                                         "No additional information available.")))}])))))

(defn set-html [_survey options]
  (let [text (.-text options)]
    (set! (.. options -html) text)))

(defn- resolve-complete-text [unsubscribe-page? complete-text unsubscribe-text]
  (if unsubscribe-page?
    {:full (or unsubscribe-text {:nl "Verstuur uitschrijving"})
     :small {:nl "Uitschrijven"}}
    {:full (or complete-text {:nl "Verstuur mijn antwoorden"})
     :small {:nl "Verstuur"}}))

(def ^:private tailwind-sm-breakpoint
  (js/window.matchMedia "(min-width: 640px)"))

(defn- resolve-button-text
  [{:keys [full small] :as _button-texts}]
  (if (.-matches tailwind-sm-breakpoint) full small))

(defn- responsive-button-text-resize-handler
  [button-texts]
  (when-let [btn (first (array-seq (js/document.getElementsByClassName "sd-btn--action")))]
    (let [responsive-text (resolve-button-text button-texts)]
      (when-let [localized-responsive-text (text-or-i18n responsive-text)]
        (set! (.. btn -textContent) localized-responsive-text)))))

(def ^:private event-listener-latch (atom false))
(defn- add-event-listener-once-for-short-text-btn [button-texts]
  (when (compare-and-set! event-listener-latch false true)
    (responsive-button-text-resize-handler button-texts)
    (try
      (.addEventListener
       tailwind-sm-breakpoint
       "change"
       (partial responsive-button-text-resize-handler button-texts))
      (catch js/Error e
        (js/console.warn e)))))

(defn panel [survey-model
             {completed-html? :completedHtml
              complete-text :completeText
              edit-text :editText
              unsubscribe-text :unsubscribeText
              survey-name :name
              :as _surveyjs-config}]
  (when config/debug?
    (prn ::panel {:questionnaire-id survey-name}))
  (let [survey-submitted-to-server? (atom false)
        unsubscribe-page? @(re-frame/subscribe [:questionnaire/unsubscribe?])
        button-texts (resolve-complete-text unsubscribe-page? complete-text unsubscribe-text)]
    (register-info-icon)
    (add-event-listener-once-for-short-text-btn button-texts)
    [:> Survey
     {:model survey-model
      :editText (or edit-text "Aanpassen")
      :showCompletedPage (or completed-html? false)
      :onGetQuestionTitleActions add-title-action-to-question
      :onLocaleChanged
      (partial responsive-button-text-resize-handler button-texts)
      :onAfterRenderPage
      (partial responsive-button-text-resize-handler button-texts)
      :onCurrentPageChanged
      (partial responsive-button-text-resize-handler button-texts)
      :onTextMarkdown set-html ; misused since it fires on all text
      :onValueChanged #(re-frame/dispatch [::events/survey-dirty-status-changed true])
      :onComplete (partial survey-complete survey-submitted-to-server?)}]))
